module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAAIVBMVEUAAAAcuuoduusduOweuukeuuofu+ofuukfuuofueofuuoxzDCqAAAACnRSTlMAJU5Pdnfc3d7nax3nwAAAAF9JREFUOMtjYKAL0FyFDlYqgCVmYUismgCWwBRftQAisQDdcPIlcNmB01WWmP4wYMBqCZxPlASjIw4JjmU4JLhWjUoMgATHclwxGEhqnNNfAntix5LcJ0AlLHEk9oEDANb9yeIbG2DLAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/views/makeTysonPenHolder/imgs/笔筒类型.png
// module id = 3C0+
// module chunks = 2